import NotesIcon from '@material-ui/icons/Notes';
export const OpmerkingenIcon = NotesIcon;

